//interfaces
import { IPWhitelistContainer } from  '@/interfaces/passkeys';

//components

import WhitelistData from './WhitelistData';
import WhitelistButtonPanel from './WhitelistButtonPanel';




const IPWhitelist = ({whitelistEnabled, whitelistTableContent, canViewRequests, canCreateRecoveryCode, onRemoveRestrictionClick, onViewRequests, onAddWhitelistAddress, onEnableWhitelistClick, onCreateCodeClick}:IPWhitelistContainer) => {  
    
    if (whitelistEnabled) {
        return  <WhitelistData 
                    whitelistTableContent={whitelistTableContent}
                    canViewRequests={canViewRequests}
                    onRemoveRestrictionClick={onRemoveRestrictionClick} 
                    onViewRequests={onViewRequests} 
                    onAddIPAddress={onAddWhitelistAddress}
                    onCreateCodeClick={onCreateCodeClick}
                    canCreateRecoveryCode={canCreateRecoveryCode}
                />
    }
    return  <WhitelistButtonPanel 
                canViewRequests={canViewRequests}
                onEnableClick={onEnableWhitelistClick}
                onViewRequests={onViewRequests} 
                onCreateCodeClick={onCreateCodeClick}
                canCreateRecoveryCode={canCreateRecoveryCode} 
            />            
}

export default IPWhitelist